import { useState, useRef } from 'react';
import { Box } from '@mui/material';
import { DatePicker, Localization } from 'react-widgets';
import { DateLocalizer } from 'react-widgets/IntlLocalizer';

function DateSelector({ dayStart, setDayStart, dayEnd, setDayEnd }) {
  const [openStart, setOpenStart] = useState(false);
  const [openEnd, setOpenEnd] = useState(false);
  const inputRefStart = useRef(null);
  const inputRefEnd = useRef(null);
  return (
    <Box style={{ display: 'flex', margin: '15px', alignItems: 'center', gap: '10px', overflow: 'visible' }}>
      <Localization
        date={
          new DateLocalizer({
            culture: 'pl-PL',
            firstOfWeek: 1,
          })
        }
      >
        <DatePicker
          value={dayStart}
          valueEditFormat={{ dateStyle: 'long' }}
          valueDisplayFormat={{ dateStyle: 'long' }}
          placeholder='Od'
          onChange={(value) => {
            setDayStart(value);
            setOpenStart(false);
          }}
          open={openStart}
          onToggle={setOpenStart}
          inputProps={{
            readOnly: true,
            ref: inputRefStart,
            onClick: () => setOpenStart(true),
            style: { cursor: 'pointer', width: '250px' },
          }}
        />
        <b style={{ margin: '0 10px' }}>-</b>
        <DatePicker
          value={dayEnd}
          valueEditFormat={{ dateStyle: 'long' }}
          valueDisplayFormat={{ dateStyle: 'long' }}
          placeholder='Do'
          onChange={(value) => {
            setDayEnd(value);
            setOpenEnd(false);
          }}
          open={openEnd}
          onToggle={setOpenEnd}
          inputProps={{
            readOnly: true,
            ref: inputRefEnd,
            onClick: () => setOpenEnd(true),
            style: { cursor: 'pointer', width: '250px' },
          }}
        />
      </Localization>
    </Box>
  );
}

export { DateSelector };
